const pick = (source, camelKey, pascalKey, fallback = undefined) => {
  if (!source || typeof source !== "object") {
    return fallback;
  }

  if (source[camelKey] !== undefined) {
    return source[camelKey];
  }

  if (source[pascalKey] !== undefined) {
    return source[pascalKey];
  }

  return fallback;
};

const normalizeTarjetaResumen = (item = {}) => ({
  ...item,
  tarjeta: pick(item, "tarjeta", "Tarjeta", ""),
  totalConDescuento: Number(
    pick(item, "totalConDescuento", "TotalConDescuento", 0)
  ),
});

const normalizeDiaTarjeta = (item = {}) => ({
  key: pick(item, "key", "Key", ""),
  value: Number(pick(item, "value", "Value", 0)),
});

const normalizeTotalesPorDiaTarjeta = (value) => {
  if (!value || typeof value !== "object") {
    return {};
  }

  return Object.entries(value).reduce((acc, [comercio, items]) => {
    acc[comercio] = Array.isArray(items)
      ? items.map((item) => normalizeDiaTarjeta(item))
      : [];
    return acc;
  }, {});
};

export const normalizeInicioPayload = (payload = {}) => {
  const comparativaMesRaw = pick(payload, "comparativaMes", "ComparativaMes", {});

  return {
    ...payload,
    totalNetoHoy: Number(pick(payload, "totalNetoHoy", "TotalNetoHoy", 0)),
    totalBrutoHoy: Number(pick(payload, "totalBrutoHoy", "TotalBrutoHoy", 0)),
    totalNetoMañana: Number(
      pick(payload, "totalNetoMañana", "TotalNetoMañana", 0)
    ),
    totalBrutoMañana: Number(
      pick(payload, "totalBrutoMañana", "TotalBrutoMañana", 0)
    ),
    totalNetoMes: Number(pick(payload, "totalNetoMes", "TotalNetoMes", 0)),
    totalBrutoMes: Number(pick(payload, "totalBrutoMes", "TotalBrutoMes", 0)),
    comparativahoy: Number(
      pick(payload, "comparativahoy", "Comparativahoy", 0)
    ),
    comparativaHoymesanterior: Number(
      pick(payload, "comparativaHoymesanterior", "ComparativaHoymesanterior", 0)
    ),
    porcentaje: Number(pick(payload, "porcentaje", "Porcentaje", 0)),
    comparativadiasemana: pick(
      payload,
      "comparativadiasemana",
      "Comparativadiasemana",
      "dia"
    ),
    comparativaMes: {
      mesActual: pick(comparativaMesRaw, "mesActual", "MesActual", ""),
      mesAnterior: pick(comparativaMesRaw, "mesAnterior", "MesAnterior", ""),
    },
    descuentosPorTarjeta: (
      pick(payload, "descuentosPorTarjeta", "DescuentosPorTarjeta", []) || []
    ).map((item) => normalizeTarjetaResumen(item)),
    totalesPorDiaTarjeta: normalizeTotalesPorDiaTarjeta(
      pick(payload, "totalesPorDiaTarjeta", "TotalesPorDiaTarjeta", {})
    ),
  };
};

export const normalizeCuponesPayload = (payload = {}) => ({
  ...payload,
  totalOperaciones: Number(
    pick(payload, "totalOperaciones", "TotalOperaciones", 0)
  ),
  totalBrutoHoy: Number(pick(payload, "totalBrutoHoy", "TotalBrutoHoy", 0)),
  contracargo: Number(pick(payload, "contracargo", "Contracargo", 0)),
  retenciones: Number(pick(payload, "retenciones", "Retenciones", 0)),
  listaMes: (pick(payload, "listaMes", "ListaMes", []) || []).map((item) => ({
    ...item,
    fecha: pick(item, "fecha", "Fecha", ""),
    costoFinancieroEn: Number(
      pick(item, "costoFinancieroEn", "CostoFinancieroEn", 0)
    ),
    totalBruto: Number(pick(item, "totalBruto", "TotalBruto", 0)),
    arancel: Number(pick(item, "arancel", "Arancel", 0)),
    iva21: Number(pick(item, "iva21", "Iva21", 0)),
    impuestoDebitoCredito: Number(
      pick(item, "impuestoDebitoCredito", "ImpuestoDebitoCredito", 0)
    ),
    retencionProvincial: Number(
      pick(item, "retencionProvincial", "RetencionProvincial", 0)
    ),
    retencionGanacia: Number(
      pick(item, "retencionGanacia", "RetencionGanacia", 0)
    ),
    retencionIva: Number(pick(item, "retencionIva", "RetencionIva", 0)),
    totalConDescuentos: Number(
      pick(item, "totalConDescuentos", "TotalConDescuentos", 0)
    ),
    tieneDocumentos: Boolean(
      pick(item, "tieneDocumentos", "TieneDocumentos", false)
    ),
  })),
});

export const normalizeOrdenPagoPayload = (payload = {}) => ({
  comercios: (pick(payload, "comercios", "Comercios", []) || []).map(
    (comercio) => ({
      comercio: pick(comercio, "comercio", "Comercio", "SIN NOMBRE"),
      info: {
        empresa: pick(pick(comercio, "info", "Info", {}), "empresa", "Empresa", ""),
        direccion: pick(pick(comercio, "info", "Info", {}), "direccion", "Direccion", ""),
        provincia: pick(pick(comercio, "info", "Info", {}), "provincia", "Provincia", ""),
        telefono: pick(pick(comercio, "info", "Info", {}), "telefono", "Telefono", ""),
        email: pick(pick(comercio, "info", "Info", {}), "email", "Email", ""),
        banco: pick(pick(comercio, "info", "Info", {}), "banco", "Banco", ""),
        nroCuenta: pick(pick(comercio, "info", "Info", {}), "nroCuenta", "NroCuenta", ""),
        alias: pick(pick(comercio, "info", "Info", {}), "alias", "Alias", ""),
      },
      tiposTarjeta: (
        pick(comercio, "tiposTarjeta", "TiposTarjeta", []) || []
      ).map((tipo) => ({
        tipoTarjeta: pick(tipo, "tipoTarjeta", "TipoTarjeta", "GENERAL"),
        acumulados: {
          hoySeAcredita: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "hoySeAcredita",
            "HoySeAcredita",
            "0,00"
          ),
          acumulado: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "acumulado",
            "Acumulado",
            "0,00"
          ),
          acumuladoDebito: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "acumuladoDebito",
            "AcumuladoDebito",
            "0,00"
          ),
          acumuladoCredito: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "acumuladoCredito",
            "AcumuladoCredito",
            "0,00"
          ),
          retencionGanancias: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "retencionGanancias",
            "RetencionGanancias",
            "0,00"
          ),
          retencionIva: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "retencionIva",
            "RetencionIva",
            "0,00"
          ),
          retencionIbb: pick(
            pick(tipo, "acumulados", "Acumulados", {}),
            "retencionIbb",
            "RetencionIbb",
            "0,00"
          ),
        },
        datos: (pick(tipo, "datos", "Datos", []) || []).map((item) => ({
          terminal: pick(item, "terminal", "Terminal", ""),
          nroOperacion: pick(item, "nroOperacion", "NroOperacion", ""),
          fechaOperacion: pick(item, "fechaOperacion", "FechaOperacion", ""),
          fechaPago: pick(item, "fechaPago", "FechaPago", ""),
          tarjeta: pick(item, "tarjeta", "Tarjeta", ""),
          cuotas: pick(item, "cuotas", "Cuotas", ""),
          bruto: pick(item, "bruto", "Bruto", "0,00"),
          costoFinanciero: pick(item, "costoFinanciero", "CostoFinanciero", "0,00"),
          costoPorAnticipo: pick(item, "costoPorAnticipo", "CostoPorAnticipo", "0,00"),
          arancel: pick(item, "arancel", "Arancel", "0,00"),
          ivaArancel: pick(item, "ivaArancel", "IvaArancel", "0,00"),
          impDebitoCredito: pick(item, "impDebitoCredito", "ImpDebitoCredito", "0,00"),
          retencionIIBB: pick(item, "retencionIIBB", "RetencionIIBB", "0,00"),
          retencionGanancia: pick(item, "retencionGanancia", "RetencionGanancia", "0,00"),
          retencionIVA: pick(item, "retencionIVA", "RetencionIVA", "0,00"),
          totalOP: pick(item, "totalOP", "TotalOP", "0,00"),
        })),
        sumas: {
          bruto: pick(pick(tipo, "sumas", "Sumas", {}), "bruto", "Bruto", "0,00"),
          costoFinanciero: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "costoFinanciero",
            "CostoFinanciero",
            "0,00"
          ),
          costoPorAnticipo: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "costoPorAnticipo",
            "CostoPorAnticipo",
            "0,00"
          ),
          arancel: pick(pick(tipo, "sumas", "Sumas", {}), "arancel", "Arancel", "0,00"),
          ivaArancel: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "ivaArancel",
            "IvaArancel",
            "0,00"
          ),
          impDebitoCredito: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "impDebitoCredito",
            "ImpDebitoCredito",
            "0,00"
          ),
          retencionIIBB: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "retencionIIBB",
            "RetencionIIBB",
            "0,00"
          ),
          retencionGanancia: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "retencionGanancia",
            "RetencionGanancia",
            "0,00"
          ),
          retencionIVA: pick(
            pick(tipo, "sumas", "Sumas", {}),
            "retencionIVA",
            "RetencionIVA",
            "0,00"
          ),
          totalOP: pick(pick(tipo, "sumas", "Sumas", {}), "totalOP", "TotalOP", "0,00"),
        },
      })),
    })
  ),
  cuit: pick(payload, "cuit", "Cuit", ""),
});
